import { Card, Grid, StyledEngineProvider, ThemeProvider, createTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";

const defaultMaterialTheme = createTheme(
    {
        palette: {
            primary: {
                main: "#0 08752"
            }
        },
        backdrop: {
            zIndex: 9999999,
            color: "#000"
        }
    }
);

function Holidays(props) {

    const appdata = useSelector(appdataSelector);

    const columns = [
        {
          field: "startDate",
          headerName: "startDate",
          width: 200
        },
        {
          field: "endDate",
          headerName: "endDate",
          width: 200
        },
        {
          field: "name",
          headerName: "name",
          width: 200,
          renderCell: (params)=>{
            return params.value[0]['text']
          }
        },
    ]
    return (
        <Grid
            className="mt-2"
            container
            spacing={2}
            alignItems="top"
            justifyContent="center"
            style={{ minHeight: "100vh" }}
        >
            <Grid item xs={12} md={10}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <Card>
                            <article className="article">
                                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                                    <h2 className="article-title">Holidays</h2>



                                    <div style={{ height: 500, width: "100%" }}>
                                        <DataGrid
                                            columns={columns}
                                            rows={
                                                // the menudata needs to be mapped, because it does not contain an ID by default (in the SAP data)
                                                // that is why we map it, and add an id to every row.
                                                // if not the DATAGRID will not work and throw an error
                                                // alternatively adding an ID in the backend would have worked,
                                                // but that will make the data dirty
                                                appdata.holidays
                                                    ? appdata.holidays.map((item, index) => ({
                                                        id: index + 1,
                                                        ...item
                                                    }))
                                                    : []
                                            }
                                        ></DataGrid>
                                    </div>
                                    <div className="mt-4">Source: openholidaysapi.org</div>    
                                </div>
                                
                            </article>
                        </Card>
                    </ThemeProvider>
                </StyledEngineProvider>
            </Grid>
        </Grid>
    )
}
export default Holidays